var o = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var a = (c, e, h) => e in c ? o(c, e, { enumerable: !0, configurable: !0, writable: !0, value: h }) : c[e] = h, n = (c, e) => {
  for (var h in e || (e = {}))
    r.call(e, h) && a(c, h, e[h]);
  if (t)
    for (var h of t(e))
      m.call(e, h) && a(c, h, e[h]);
  return c;
};
var i = (c, e) => {
  var h = {};
  for (var l in c)
    r.call(c, l) && e.indexOf(l) < 0 && (h[l] = c[l]);
  if (c != null && t)
    for (var l of t(c))
      e.indexOf(l) < 0 && m.call(c, l) && (h[l] = c[l]);
  return h;
};
import * as s from "react";
const g = (l) => {
  var v = l, {
    title: c,
    titleId: e
  } = v, h = i(v, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ s.createElement("svg", n({ height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", "aria-labelledby": e }, h), c ? /* @__PURE__ */ s.createElement("title", { id: e }, c) : null, /* @__PURE__ */ s.createElement("path", { d: "m10 32c-2.61976548-.0048219-4.75381422-2.1054372-4.8-4.7248l-1.4656-17.6752h-.1344c-.8836556 0-1.6-.7163444-1.6-1.6s.7163444-1.6 1.6-1.6h1.464c.09103271-.0078119.18256729-.0078119.2736 0h4.6624v-3.2c0-1.7673112 1.4326888-3.2 3.2-3.2h6.4c1.7673112 0 3.2 1.4326888 3.2 3.2v3.2h4.664c.0910327-.0078119.1825673-.0078119.2736 0h1.4736c.8836556 0 1.6.7163444 1.6 1.6s-.7163444 1.6-1.6 1.6h-.1312l-1.4752 17.6752c-.0461858 2.6193628-2.1802345 4.7199781-4.8 4.7248zm-1.6-4.9376c0 .0496.0096.0976.0096.1344 0 .8836556.7163444 1.6 1.6 1.6h12.8c.8836556 0 1.6-.7163444 1.6-1.6v-.1344l1.4544-17.4624h-18.9168zm11.2-20.6592v-3.2h-6.4v3.2zm-1.6 17.6v-9.6c0-.8836556.7163444-1.6 1.6-1.6s1.6.7163444 1.6 1.6v9.6c0 .8836556-.7163444 1.6-1.6 1.6s-1.6-.7163444-1.6-1.6zm-6.4 0v-9.6c0-.8836556.7163444-1.6 1.6-1.6s1.6.7163444 1.6 1.6v9.6c0 .8836556-.7163444 1.6-1.6 1.6s-1.6-.7163444-1.6-1.6z" }));
};
export {
  g as default
};
